export function getCommonCardStateColor(state: string | null): string {
  switch (state?.toLowerCase()) {
    case 'rejected':
      return 'bg-red-500';
    case 'pending':
      return 'bg-info-base';
    case 'approved':
      return 'bg-success-base';
    case 'disabled':
      return 'bg-neutral-light';
    case 'blocked':
      return 'bg-neutral-light';
    case 'finished':
      return 'bg-neutral-dark';
    default:
      return 'bg-neutral-dark';
  }
}

export function getProjectSystemCardStateColor(state: string | null): string {
  switch (state?.toLowerCase()) {
    case 'rejected':
    case 'desarrollo rechazado':
    case 'despliegue rechazado':
      return 'bg-red-500';
    case 'pending':
    case 'desarrollo solicitado':
    case 'despliegue solicitado':
      return 'bg-info-base';
    case 'approved':
    case 'despliegue revisado':
    case 'desarrollo validado':
    case 'despliegue validado':
    case 'desarrollado y revisado':
    case 'despliegue desarrollado y revisado':
      return 'bg-success-base';
    case 'development':
    case 'en desarrollo':
      return 'bg-warning-base';
    case 'correction':
    case 'desarrollo en subsanación':
    case 'despliegue en subsanación':
      return 'bg-alert-base';
    case 'operation':
      return 'bg-primary-base';
    case 'finalized':
    case 'desarrollo finalizado':
    case 'despliegue finalizado':
      return 'bg-success-dark';
    case 'canceled':
    case 'desarrollo cancelado':
    case 'despliegue cancelado':
      return 'bg-alert-base';
    default:
      return 'bg-neutral-dark';
  }
}
